import React from 'react'
import HeroSection from '../component/HeroSection'
import ApartmentShowcase from '../component/ApartmentsOverviewWithImages'
import AmenitiesSection from '../component/AmenitiesSection'
import AboutSection from '../component/AboutSection'
import DiningSectionSimple from '../component/LocationLifestyle'
import TestimonialsSection from '../component/TestimonialsSection'
import ContactSection from '../component/ContactSection'
import VideoSection from '../component/VideoSection'
import FAQsSectionApartment from '../component/FaqSectionApartment'
import WhyChooseUsNewSection from '../component/WhyChooseUsNewSection'

const Home = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ApartmentShowcase />
      <DiningSectionSimple />
      <AmenitiesSection />
      <VideoSection />
      <TestimonialsSection />
      <FAQsSectionApartment />
      <ContactSection />

      {/* <FixedBackgroundAmenities/> */}
    </>
  )
}

export default Home
